import { render } from "./RichEditor.vue?vue&type=template&id=14afe1ee"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__